import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { configureStore } from 'app-webtech-core';
import { Application } from 'app-modules/application/containers/Application';
import { createEntrypoint } from 'app-modules/application/utils/createEntrypoint';
import { configureLiveOverride } from 'app-modules/application/utils/firebase';
import { customReducers, customPersistConfig } from './reducers';
import { routeOptions, routesDefinition } from './routes';
import './main.css';
import { setupBeacon } from './setupBeacon';
import * as triviaActions from './modules/trivia/actions';
import * as chatActions from './modules/chat/actions';
import * as wamDialogsActions from './modules/wamDialogs/actions';
import { createLastVisitCookie } from './utils/lastVisit';
import './modules/application/utils/i18n';

(async () => {
  createLastVisitCookie();

  const root = document.getElementById('root');
  const render = (Component, store, persistor) => {
    ReactDOM.hydrate(createEntrypoint(Component, { store, persistor }), root);
  };

  const { store, persistor } = configureStore({
    routesDefinition,
    routeOptions,
    customReducers,
    customPersistConfig,
    customDevToolsOptions: {
      actionCreators: {
        trivia: triviaActions,
        chat: chatActions,
        wamDialogs: wamDialogsActions,
      },
      actionsBlacklist: [
        'UI',
        'POD',
        'PLAYER_INTERNAL_SAVE_PLAYBACK_POSITION',
        'APPLICATION_APP_LAUNCH_TRACK',
        '___BEACON',
      ],
    },
  });

  const visibilityOverrideDispatcher = (enabled) =>
    store.dispatch(chatActions.visibilityOverride(enabled));
  configureLiveOverride(visibilityOverrideDispatcher);

  await store.dispatch(setupBeacon());
  render(Application, store, persistor);

  if (module.hot && process.env.NODE_ENV === 'development') {
    module.hot.accept('./modules/application/containers/Application', () => {
      // eslint-disable-next-line global-require
      const ReloadedApplication = require('./modules/application/containers/Application')
        .Application;

      render(ReloadedApplication, store, persistor);
    });
  }
})();
